<div class="w-full">
    <form [formGroup]="searchModel">

        <div class="mt-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>
                    {{'REPORTS.FILTERS.SELECT_DATE'|translate}}
                </mat-label>
                <input matInput ngxDaterangepickerMd startKey="startDate" endKey="endDate" required
                    [lockStartDate]="false" [(ngModel)]="selectedDate" [ngModelOptions]="{standalone: true}"
                    [locale]="locale" [ranges]="ranges" [showDropdowns]="true" [showCustomRangeLabel]="true"
                    [min]="minDate" [max]="maxDate" [closeOnAutoApply]="true" [opens]="'right'" [drops]="'down'"
                    [linkedCalendars]="true" [keepCalendarOpeningWithRange]="true" [showRangeLabelOnInput]="false"
                    [dateLimit]="30" (datesUpdated)="chosenDateTime($event)" />
            </mat-form-field>
        </div>

        <div class="mt-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>{{'TAGITEMPROPERTY.SEARCH_TERMS' | translate}}</mat-label>
                <input matInput type="text" class="form-control" formControlName="searchTerm" id="searchTerm"
                    maxlength="50">
            </mat-form-field>
        </div>

        <div class="mt-4">
            <div formArrayName="filterQuery">

                <table class="table-full divide-y divide-gray-300">
                    <thead class="bg-gray-50 divide-y divide-gray-300">
                        <tr>
                            <th class="px-6 py-2 text-xs text-gray-500 text-left">
                                {{'TAGITEMPROPERTY.FIELDS.FILTER_QUERY' | translate}}</th>
                            <th class="px-6 py-2 text-xs text-gray-500 text-center">
                                {{'SYSTEM.RECORD.VALUE'|translate}}</th>
                            <th class="px-6 py-2 text-xs text-gray-500  text-center">
                                {{'SYSTEM.RECORD.ACTION_BUTTON' |translate}}
                            </th>
                            <th class="px-6 py-2 text-xs text-gray-500  text-right">
                                <button mat-icon-button (click)="addFilterQuery()" color="primary">
                                    <fa-icon [icon]="['fal', 'plus']"></fa-icon>
                                    <!-- <mat-icon class="icon-size-15" [svgIcon]="'heroicons_solid:plus-circle'">
                                    </mat-icon> -->
                                </button>

                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white">
                        <tr [formGroupName]="y" *ngFor="let filterQuery of filterQueryData.controls; let y = index">
                            <td class="w-30 text-left">
                                <mat-form-field class="fuse-mat-no-subscript flex-auto w-full pr-1 pt-4"
                                    appearance="fill">
                                    <mat-label>{{'TAGITEMPROPERTY.FIELDS.FILTER_QUERY'|translate}}
                                    </mat-label>
                                    <mat-select formControlName="name" #selectedItems required>
                                        <mat-option *ngFor="let item of tagItemTemplateData" [value]="item">
                                            {{item.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="w-full text-center">
                                <ng-container *ngIf="selectedItems.value?.valueType === 0">
                                    <mat-form-field appearance="fill" class="w-full">

                                        <input matInput type="text" class="form-control" required
                                            formControlName="value" [maxlength]="$safeNavigationMigration(selectedItems.value?.maxValue)"
                                            [minlength]="$safeNavigationMigration(selectedItems.value?.minValue)">

                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="selectedItems.value?.valueType === 1">
                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>{{selectedItems.value?.name}}</mat-label>
                                        <mat-select formControlName="value">
                                            <mat-option
                                                *ngFor="let item of selectedItems.value?.defaultValue.split(','); let d=index"
                                                [value]="item">
                                                {{item}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="selectedItems.value?.valueType === 2">
                                    <mat-form-field appearance="fill" class="w-full">
                                        <input matInput type="password" class="form-control" formControlName="value"
                                            [max]="$safeNavigationMigration(selectedItems.value?.max)" [min]="$safeNavigationMigration(selectedItems.value?.min)">

                                    </mat-form-field>
                                </ng-container>

                                <ng-container *ngIf="selectedItems.value?.valueType === 3">
                                    <div>
                                        <app-toggle-switch class="custom-toggle-margin" name="y"
                                            [(ngModel)]="isRangeSelection" [ngModelOptions]="{standalone: true}"
                                            color="primary">

                                            <span class="text-xs">
                                                {{'RULE.ACCESSRULE_PARAMS.FIELDS.RANGE'|translate}}?</span>

                                        </app-toggle-switch>

                                        <ng-container *ngIf="!isRangeSelection">
                                            <mat-form-field appearance="fill" class="w-full">
                                                <input matInput type="number" class="form-control"
                                                    formControlName="value" [max]="$safeNavigationMigration(selectedItems.value?.max)"
                                                    [min]="$safeNavigationMigration(selectedItems.value?.min)">
                                            </mat-form-field>
                                        </ng-container>

                                        <ng-container *ngIf="isRangeSelection">
                                            <div
                                                *ngIf="$safeNavigationMigration(selectedItems.value?.min) !== null && $safeNavigationMigration(selectedItems.value?.max) !== null; else elseNoMinMaxTemplate">
                                                <ngx-slider formControlName="value"
                                                    [value]="$safeNavigationMigration(selectedItems.value?.min) !== null ? $safeNavigationMigration(selectedItems.value?.min): 0"
                                                    [highValue]="$safeNavigationMigration(selectedItems.value?.max) !== null ? $safeNavigationMigration(selectedItems.value?.max): 0"
                                                    [options]="{
                                                                 step:1,
                                                                 floor: $safeNavigationMigration(selectedItems.value?.min) !== null ? $safeNavigationMigration(selectedItems.value?.min): 0,
                                                                 ceil: $safeNavigationMigration(selectedItems.value?.max) !== null ? $safeNavigationMigration(selectedItems.value?.max) : 100,
                                                                 disabled: false,
                                                                 showTicks: false,
                                                                 showSelectionBar: true
                                                               }">
                                                </ngx-slider>
                                            </div>

                                            <ng-template #elseNoMinMaxTemplate>
                                                <mat-form-field appearance="fill" class="w-full">
                                                    <input matInput type="number" class="form-control"
                                                        formControlName="value" [max]="$safeNavigationMigration(selectedItems.value?.max)"
                                                        [min]="$safeNavigationMigration(selectedItems.value?.min)">
                                                </mat-form-field>

                                            </ng-template>
                                        </ng-container>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="selectedItems.value?.valueType === 5">
                                    <div class="w-full pr-4 text-center">
                                                                                 <app-toggle-switch formControlName="value" [onIcon]="['fas', 'check']" [offIcon]="['fas', 'times']" [label]="'TAGITEMPROPERTY.FIELDS.IS_DEFAULT'|translate">
                                         </app-toggle-switch>
                                    </div>
                                </ng-container>

                            </td>

                            <td class="w-full pr-2 text-right">
                                <button mat-icon-button type="button" (click)="removeFilterQuery(y)"
                                    matTooltip="Remove">
                                    <fa-icon [icon]="['fal', 'trash']"></fa-icon>
                                    <!-- <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'">
                                    </mat-icon> -->
                                </button>
                            </td>

                        </tr>
                    </tbody>
                </table>

            </div>

        </div>

    </form>

</div>
